module.exports = __webpack_public_path__ + "img/main.592ace52.jpg";